import Icons from "assets";
import { Button } from "ui/button";

import {
  getFieldAction,
  getFieldButtonIcon,
  getFieldButtonColor,
  getFieldButtonVariant,
  getFieldTitle,
  type JsonFormSchema,
} from "containers/admin/clients/client/components/form-builder/form-schema";

export type FormBuilderActions = Record<string, () => void>;

type FormBuilderActionButtonProps = {
  name: string;
  field: JsonFormSchema;
  actions?: FormBuilderActions;
};

const BUTTON_ICONS = {
  trash: Icons.Trash,
} as const;

const FormBuilderActionButton = ({ name, field, actions }: FormBuilderActionButtonProps) => {
  const actionId = getFieldAction(field);
  const onAction = actionId ? actions?.[actionId] : undefined;

  if (!onAction) {
    return null;
  }

  const label = getFieldTitle(name, field);
  const iconName = getFieldButtonIcon(field);
  const Icon = iconName ? BUTTON_ICONS[iconName] : undefined;

  return (
    <div className="flex">
      <Button
        type="button"
        color={getFieldButtonColor(field)}
        variant={getFieldButtonVariant(field)}
        startIcon={Icon ? <Icon /> : undefined}
        onClick={onAction}
        data-testid={`form-builder-action-${actionId}`}
      >
        {label}
      </Button>
    </div>
  );
};

export default FormBuilderActionButton;
